module.exports = __webpack_public_path__ + "static/media/baseline-help-24px-purple.645c1e6e.svg";